export const ORDER_A_LA_CARTE_LABEL = 'Order A La Carte';
